// stores/singlePageStore.ts
import { defineStore } from 'pinia'
import { ref } from 'vue'
import * as CmsService from '@/services/cms.service'
import type { Page } from '@/models/Page'
import { getSinglePage } from '@/services/cms.service'
import fallbackImage from '@/assets/images/cosmos_logo_black.png'
import {useLocalization} from "@/locales/localization";



export const useSinglePageStore = defineStore('singlePage', () => {
    const page = ref<Page | null>(null)
    const loading = ref(false)
    const { currentLocale } = useLocalization();


    async function fetchPage(slug: string) {
        loading.value = true
        try {
            const { data } = await CmsService.getSinglePage(slug, currentLocale.value)
            // Assign default image if not available
            if (!data.heroImage || !data.heroImage.full) {
                data.heroImage = {
                    full: fallbackImage // adjust the path if needed
                }
            }
            page.value = data
        } catch (e) {
            page.value = null
            console.error('Failed to load page:', e)
        } finally {
            loading.value = false
        }
    }

    return { page, loading, fetchPage }
})